var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheduleReportDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 8.33854V12.5052C18.3337 16.6719 16.667 18.3385 12.5003 18.3385H7.50033C3.33366 18.3385 1.66699 16.6719 1.66699 12.5052V7.50521C1.66699 3.33854 3.33366 1.67188 7.50033 1.67188H11.667",
    stroke: "#717C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3337 8.33854H15.0003C12.5003 8.33854 11.667 7.50521 11.667 5.00521V1.67188L18.3337 8.33854Z",
    stroke: "#717C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 10.8281H10.833",
    stroke: "#717C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83301 14.1719H9.16634",
    stroke: "#717C90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheduleReportDark);
export default __webpack_public_path__ + "static/media/shedule-report-dark.131e40ea11bd8403431a105adf82bd00.svg";
export { ForwardRef as ReactComponent };